module.exports = __webpack_public_path__ + "img/student-record.160885d3.svg";